export default __webpack_public_path__ + "static/media/guobastand_guolba.7bc8457b.png";